import Immutable from 'immutable';
import { HOME_PATH } from '../../../config/paths';

const INITIAL_STATE = Immutable.Map({
  breadcrumbs: [
    {
      text: 'Inicio',
      tag: 'a',
      href: HOME_PATH,
    },
  ],
});

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    default:
      return state;
  }
};
